import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["variant", "intent", "className"];
import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../Base';
var styles = {
  "root": "Badge-root_2O7T4",
  "plain": "Badge-plain_3MOB3",
  "light": "Badge-light_219hF",
  "intentInfo": "Badge-intentInfo_1YPZp",
  "intentSuccess": "Badge-intentSuccess_2ghax",
  "intentWarning": "Badge-intentWarning_2aUHB",
  "intentDanger": "Badge-intentDanger_1Tpoo",
  "intentPromotional": "Badge-intentPromotional_sbT5N"
};
function Badge(_ref) {
  var _clsx;
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'plain' : _ref$variant,
    intent = _ref.intent,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Base, _extends({
      tagName: "span",
      boxSizing: "border",
      display: "inline-block",
      borderTopRightRadius: "1x",
      borderBottomLeftRadius: "1x",
      size: "small",
      weight: variant === 'plain' ? 'semibold' : 'regular',
      className: clsx(styles.root, (_clsx = {}, _defineProperty(_clsx, styles[variant], variant), _defineProperty(_clsx, styles.intentInfo, intent === 'info'), _defineProperty(_clsx, styles.intentSuccess, intent === 'success'), _defineProperty(_clsx, styles.intentWarning, intent === 'warning'), _defineProperty(_clsx, styles.intentDanger, intent === 'danger'), _defineProperty(_clsx, styles.intentPromotional, intent === 'promotional'), _clsx), className)
    }, extraProps))
  );
}
export default Badge;